import React, { Component } from "react";
import FaDashboard from "react-icons/lib/fa/dashboard";
import FaTrophy from "react-icons/lib/fa/trophy";
import FaOff from "react-icons/lib/fa/power-off";
import FaCog from "react-icons/lib/fa/cog";
/*import FaClock from "react-icons/lib/fa/clock-o";
import FaFile from "react-icons/lib/fa/file-o";
import FaBriefcase from "react-icons/lib/fa/briefcase";*/

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeScreen: 0
    };
  }

  isToggled() {
    return this.props.toggleState ? "" : " small";
  }

  isActive(id) {
    return this.props.activeScreen === id ? " active" : "";
  }

  render() {
    return (
      <nav>
        {/* <div className='searchBox' onClick={() => this.props.toggle()}>
          <p>Suche</p>
        </div> 

        <div className="navBox">
          <div className="caseCount">{this.props.cases}</div>
        </div>*/}
        <div
          className={"navBox" + this.isActive(0) + this.isToggled()}
          onClick={() => this.props.switchScreen(0)}
        >
          <FaTrophy />

          {/*<p> Tagesroutine</p>*/}
        </div>
        <div
          className={"navBox" + this.isActive(1) + this.isToggled()}
          /*onClick={() => this.props.switchScreen(1)}*/
        >
          <FaDashboard />
          {/*<p> Dashboard</p>*/}
        </div>
        {/* <div className={'navBox' + this.isActive(2) + this.isToggled()} onClick={() => this.props.switchScreen(2)}>
          <FaBriefcase />
          <p> Akte</p>
        </div> */}
        <div className={"navBox" + this.isActive(3) + this.isToggled()}>
          <FaCog />
          {/*<p>Einstellung</p>~*/}
        </div>
        <div
          className={"navBox" + this.isToggled()}
          onClick={() => this.props.logout()}
        >
          <FaOff />
          {/*<p onClick={() => this.props.switchScreen(3)}> Logout</p>*/}
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar.js